import gql from 'graphql-tag';

import client from '../graphqlAPI';

const SEARCH_EVENT_QUERY = gql`
  query searchTickets($search: String!, $eventSlugName: String!) {
    searchTickets(search: $search, eventSlugName: $eventSlugName) {
      ticketSlugName
      ticketReadableName {
        en
      }
      description {
        en
      }
      price
      currency
    }
  }
`;

const getSearchTickets = async (search, eventSlugName) => {
  try {
    const result = await client
      .query({
        query: SEARCH_EVENT_QUERY,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        variables: { search, eventSlugName },
        fetchResults: true,
        pollInterva: 300000,
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });
    const {
      data: { searchTickets },
    } = result;

    if (searchTickets) {
      return searchTickets;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: searchArtistSets`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: searchArtistSets Error: ${error}`);
    return null;
  }
};

export default getSearchTickets;
